import WHSummary from './WHSummary.vue';

export default WHSummary;


// WEBPACK FOOTER //
// ./src/components/WHSummary/index.js